export const DAYS_LABELS = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];
export const DAY_LABELS = DAYS_LABELS;
export const DAYS = DAYS_LABELS;

// Émoji de chaque humeur. Les clés sont les valeurs de `enums.Mood` côté backend.
//
// Ce dictionnaire vivait en cinq exemplaires (Mental, Home, Calendrier, Coach,
// CoachSportive), avec des replis différents d'un écran à l'autre — 😊 ici, 😶 là.
// Une humeur ajoutée au backend n'apparaissait que là où quelqu'un avait pensé à la
// recopier.
export const MOOD_EMOJI = {
  'Calme': '😌',
  'Heureuse': '😊',
  'Énergique': '⚡',
  "Sautes d'humeur": '😤',
  'Irritable': '😠',
  'Triste': '😢',
  'Angoissée': '😰',
  'Déprimée': '😔',
  "Manque d'énergie": '🥱',
  'Autocritique': '🫤',
};
